{
  "goto_totals": "Snel naar totaal van de lijst"
}
